class HotspotToggle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', function(e){
      e.preventDefault();
      var parent = this.closest('.tabbed-content');
      var allContent = parent.querySelectorAll('hotspot-content');

      for (let i = 0; i < allContent.length; i++) {
        const element = allContent[i];
        element.classList.remove('active');
      }
      
      var dataId = this.getAttribute('data-id');
      if (dataId) {
        parent.querySelector('hotspot-content[data-id="'+ dataId +'"]').classList.add('active');
      }
    });
  }
}

customElements.define("hotspot-toggle", HotspotToggle);